import React, { useState, useEffect } from 'react';
import { CgClose } from 'react-icons/cg';
import Modal from '../../../../../components/Modal';
import TextAreaEditor from '../../../../../components/Form/TextAreaEditor';
import Input from '../../../../../components/Form/Input';
import Select from '../../../../../components/Form/Select';
import { BiPlus } from 'react-icons/bi';
import { HiPencil } from 'react-icons/hi';
import axios from 'axios';
import {RESUME_API_END_POINT as api} from "../../../../../utils/constant"
import { useOutletContext } from 'react-router-dom';
import ButtonBlack from '../../../../../components/Buttons/ButtonBlack';

const Education = ({data, setData}) => {
    const [educations, setEducations] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [currentEducation, setCurrentEducation] = useState(null);
    const {showNotif, setShowNotif} = useOutletContext()
    const [isLoading, setIsLoading] = useState(false)
    const [formData, setFormData] = useState({
        resume_id: data?.id,
        school: '',
        degree: '',
        address: '',
        start_month: '',
        start_year: '',
        end_month: '',
        end_year: '',
        description: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    useEffect(() => {
    if (data) {
        setEducations(data?.educations)
        
    }
    }, [data]);

    const handleAddEducation = async (education) => {
        // console.log("Education",education)
        // try {
        //     const response = await axios.post(`${api}/educations`, education);
        //     setEducations([...educations, response.data]);
        //     setShowAddModal(false);
        // } catch (error) {
        //     console.error('Failed to add education', error);
        // }
        setIsLoading(true)
        const dataToSend = {...education, resume_id:data?.id}
        console.log('Adding experiment', dataToSend);
        try {
            const response = await axios.post(`${api}/educations/save`, dataToSend);
            if (response.data?.education) {
            setShowNotif({ ...showNotif, variant: "success", message: response?.data?.message, show: true });
            setEducations([...educations, response.data?.education]);
            setShowAddModal(false);            
        }
        setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
            console.error('Failed to add education', error);
        }
    };

    const handleEditEducation = async (education) => {
        // try {
        //     const response = await axios.put(`${api}/educations/${education.id}`, education);
        //     setEducations(educations.map(ed => (ed.id === education.id ? response.data : ed)));
        //     setShowEditModal(false);
        // } catch (error) {
        //     console.error('Failed to update education', error);
        // }

                setIsLoading(true)
                console.log("Update data", education)
                try {
                    const response = await axios.put(`${api}/educations/${education.id}`, education);
                    if (response.data?.education) {
                        setShowNotif({ ...showNotif, variant: "success", message: response?.data?.message, show: true });
                        setEducations(educations?.map(exp => exp.id === education.id ? response.data?.education : exp));
                        setShowEditModal(false);
                    }
                setIsLoading(false)
                } catch (error) {
                    setIsLoading(false)
                    setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
                    console.error('Failed to update education', error);
                }
    };

    const handleDeleteEducation = async (id) => {
        try {
            await axios.delete(`${api}/educations/${id}`);
            setEducations(educations.filter(ed => ed.id !== id));
        } catch (error) {
            console.error('Failed to delete education', error);
        }
    };

    const openEditModal = (education) => {
        // setCurrentEducation(education);
        setFormData((prev) => ({ ...prev, ...education }));
        setShowEditModal(true);
    };

    return (
        <div className="flex-col text-start border p-4 rounded-md">
            <div className="flex justify-between items-center mb-4">
                <div className='font-semibold'>Education</div>
                <button onClick={() => setShowAddModal(true)} className="bg-neutral-50 border rounded-sm p-1">
                    <BiPlus className='w-5 h-5 text-neutral-500' />
                </button>
            </div>
            
            {educations?.map((ed, index) => (
                <div key={ed.id} className={(index !== educations.length - 1) ? "border-b py-4 flex gap-4 items-start w-full mb-4" : "border-none pt-4 flex gap-4 items-start w-full mb-4"}>
                    <div className='w-full'>
                        <div className="flex justify-between items-end mb-2">
                        <div className="rounded-full bg-gray-50 border border-gray-300 flex items-center justify-center size-12 min-w-12">
                                <svg width="24px" height="24px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"
                                className='size-7 ' 
                                >
                                <path d="M7.5 4.5L11.5 6.5V14.5H3.5V6.5L7.5 4.5ZM7.5 4.5V0M0 14.5H15M1.5 14.5V8.5H3.5M13.5 14.5V8.5H11.5M6.5 14.5V11.5H8.5V14.5M7.5 0.5H10.5V2.5H7.5M7.5 9.5C6.94772 9.5 6.5 9.05228 6.5 8.5C6.5 7.94772 6.94772 7.5 7.5 7.5C8.05228 7.5 8.5 7.94772 8.5 8.5C8.5 9.05228 8.05228 9.5 7.5 9.5Z" stroke="#6b7280"/>
                                </svg>
                                </div>
                            <div className="text-start flex-col">
                                <h6 className='font-semibold'>{ed.school}</h6>
                                <div className="inline-block gap-2 text-sm">
                                    {ed.diploma} in {ed.address}
                                </div>
                            </div>
                            <p className='text-sm'>{ed.start_year}-{ed.end_year}</p>
                            <button onClick={() => openEditModal(ed)} className="bg-neutral-50 border rounded-sm p-1">
                                <HiPencil className='w-5 h-5 text-neutral-500' />
                            </button>
                        </div>
                        <p className='text-primary-text'>{ed.description}</p>
                    </div>
                </div>
            ))}

            <EducationModal
                isOpen={showAddModal}
                onClose={() => setShowAddModal(false)}
                onSave={handleAddEducation}
                title="Ajouter une éducation"
                formData={formData}
                setFormData={(value)=>setFormData(value)}
                setValue={(value) => setFormData({ ...formData, description: value })} 
                isLoading={isLoading}
                handleChange={handleChange}
            />

            <EducationModal
                isOpen={showEditModal}
                onClose={() => setShowEditModal(false)}
                onSave={handleEditEducation}
                education={currentEducation}
                title="Modifier une éducation"
                formData={formData}
                setFormData={(value)=>setFormData(value)}
                setValue={(value) => setFormData({ ...formData, description: value })} 
                isLoading={isLoading}
                handleChange={handleChange}
            />
        </div>
    );
};

const EducationModal = ({ isOpen, onClose, onSave, education, title, formData, setFormData, handleChange, setValue, isLoading }) => {
    // const [formData, setFormData] = useState({
    //     school: '',
    //     degree: '',
    //     address: '',
    //     start_month: '',
    //     start_year: '',
    //     end_month: '',
    //     end_year: '',
    //     description: ''
    // });

    // useEffect(() => {
    //     if (education) {
    //         setFormData({
    //             school: education.school || '',
    //             degree: education.degree || '',
    //             address: education.address || '',
    //             start_month: education.start_month || '',
    //             start_year: education.start_year || '',
    //             end_month: education.end_month || '',
    //             end_year: education.end_year || '',
    //             description: education.description || ''
    //         });
    //     }
    // }, [education]);

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({ ...formData, [name]: value });
    // };

    const handleSubmit = () => {
        onSave(formData);
        setFormData({
            school: '',
            degree: '',
            address: '',
            start_month: '',
            start_year: '',
            end_month: '',
            end_year: '',
            description: ''
        });
    };

    const months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 1980 + 1 }, (_, i) => (1980 + i).toString());

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="flex items-center justify-between py-2 px-4">
                <p>{title}</p>
                <button onClick={onClose} className='px-2 py-2 rounded-md border text-primary-black'>
                    <CgClose />
                </button>
            </div>
            <hr className='mb-6' />
            <div className="px-6 space-y-4 mb-4">
                <Input label="École" name="school" value={formData?.school} onChange={handleChange} />
                <Input label="Diplôme" name="degree" value={formData?.degree} onChange={handleChange} />
                <Input label="Adresse" name="address" value={formData?.address} onChange={handleChange} />
                <div className="grid grid-cols-4 gap-4 items-end">
                    <Select label="Mois de début" name="start_month" value={formData?.start_month} onChange={handleChange} options={months} />
                    <Select label="Année de début" name="start_year" value={formData?.start_year} onChange={handleChange} options={years} />
                    <Select label="Mois de fin" name="end_month" value={formData?.end_month} onChange={handleChange} options={months} />
                    <Select label="Année de fin" name="end_year" value={formData?.end_year} onChange={handleChange} options={years} />
                </div>
                <TextAreaEditor label="Description" name="description" value={formData?.description} setValue={(value) => setFormData({ ...formData, description: value })} />
            </div>
            <div className="flex items-center justify-end p-6">
            <ButtonBlack isLoading={isLoading} onClick={()=>onSave(formData)} className="py-2 px-6 rounded-sm shadow bg-primary-black text-white">
                    Enregistrer
                </ButtonBlack>
            </div>
        </Modal>
    );
};

export default Education;
